export const INLINE_SELECT_PROPS = {
  size: 'sm',
  variant: 'filled',
  colorScheme: 'white',
  width: 'fit-content',
  minW: 'unset',
  mx: 1,
  pl: 1,
  cursor: 'pointer',
  fontWeight: '600',
  color: 'blue.600',
  backgroundColor: 'white !important',
} as const;
